import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-translation',
  templateUrl: './edit-translation.component.html',
  styleUrls: ['./edit-translation.component.css']
})
export class EditTranslationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
